import React from 'react'
import { STATUS_LABELS, TYPE_LABELS } from './constants'
import { PurchaseOrder } from './types'
import {
  Card,
  CardDesc,
  CardFoot,
  CardId,
  CardMeta,
  CardMetaItem,
  CardMetaLabel,
  CardMetaValue,
  CardTitle,
  CardTop,
  CardTopActions,
  CardTypeTag,
  CardValue,
  StatusBadge,
} from './style'

const formatDate = (value: string | null) => {
  if (!value) return '-'
  return new Date(value).toLocaleDateString('pt-BR')
}

interface OrderCardProps {
  order: PurchaseOrder
  onClick?: () => void
  actions?: React.ReactNode
}

const OrderCard = React.forwardRef<HTMLDivElement, OrderCardProps>(({ order, onClick, actions }, ref) => (
  <Card ref={ref} onClick={onClick} $clickable={Boolean(onClick)}>
    <CardTop>
      <div>
        <CardTitle>{order.title}</CardTitle>
        <CardId>{order.code} · aberto em {formatDate(order.createdAt)}</CardId>
      </div>
      <CardTopActions>
        <StatusBadge $status={order.status}>{STATUS_LABELS[order.status] || order.status}</StatusBadge>
        {actions}
      </CardTopActions>
    </CardTop>

    {order.description && <CardDesc>{order.description}</CardDesc>}

    <CardMeta>
      <CardMetaItem>
        <CardMetaLabel>Fornecedor</CardMetaLabel>
        <CardMetaValue>{order.SupplierCompany?.companyName || '-'}</CardMetaValue>
      </CardMetaItem>
      <CardMetaItem>
        <CardMetaLabel>Prazo</CardMetaLabel>
        <CardMetaValue>{formatDate(order.deadline)}</CardMetaValue>
      </CardMetaItem>
    </CardMeta>

    <CardFoot>
      <CardTypeTag $type={order.type}>{TYPE_LABELS[order.type] || order.type}</CardTypeTag>
      <CardValue>R$ {Number(order.totalValue).toFixed(2)}</CardValue>
    </CardFoot>
  </Card>
))

OrderCard.displayName = 'OrderCard'

export default OrderCard
